import React, { Component } from 'react';
import Link from 'next/link';
import { Wrapper, Container, Heading, Tagline, Button } from './styles';
import Events from '../Events';

class Locations extends Component {
  render() {
    const { events } = this.props;

    return (
      <Wrapper>
        <Container>
          <Heading>Dates</Heading>
          <Tagline>
            Webinar format is by way of video with a <span className='bold'>live chat function</span> providing tutors to answer
            questions throughout the day. Includes access to an online question bank and unique mock test.
          </Tagline>
          <Tagline className='underline'>
            All courses sell out well in advance. Early booking is recommend.
          </Tagline>
          <Link href="/book">
            <a>
              <Button>Book Now</Button>
            </a>
          </Link>
          <Events {...{ events }} />
        </Container>
      </Wrapper>
    );
  }
}

export default Locations;
